export default __webpack_public_path__ + "static/iCARE-Industry-bb88b73c710491c9ec62ca4b2fc2cda2.png";